import * as React from "react";
import {TasksList,TasksGraph,ConfirmationCalls, ProposalPage, KpiPage, PaymentsPage, CustomerDetailsPage, StorageExpectedIncomePage, McOpsDashboardPage} from "../../screens";
import {ErrorComponent} from "../../components/errors";
import {urls} from "./urls";


export const TASKS_LIST_ROUTE = {
    path: urls.tasksList,
    element: <TasksList />
};
export const TASKS_GRAPH_ROUTE = {
    path: urls.tasksGraph,
    element: <TasksGraph/>
};

export const CONFIRMATION_CALLS_ROUTE = {
    path: urls.confirmationCalls,
    element: <ConfirmationCalls/>
};
export const STATISTICS = {
    path: urls.statistics,
    element: <ProposalPage/>
};
export const KPI_ROUTE = {
    path: urls.kpi,
    element: <KpiPage/>
};
export const PAYMENTS_ROUTE = {
    path: urls.payments,
    element: <PaymentsPage/>
};
export const CUSTOMER_DETAILS_ROUTE = {
    path: `${urls.payments}/:profileId`,
    element: <CustomerDetailsPage/>
};
export const STORAGE_EXPECTED_INCOME_ROUTE = {
    path: urls.storageExpectedIncome,
    element: <StorageExpectedIncomePage/>
};
export const MC_OPS_DASHBOARD_ROUTE = {
    path: urls.mcOpsDashboard,
    element: <McOpsDashboardPage/>
};
export const MC_OPS_JOB_ROUTE = {
    path: urls.mcOpsJob,
    element: <McOpsDashboardPage/>
};
export const ERROR_ROUTE = {
    path: urls.error,
    element: <ErrorComponent />
};


export const PUBLIC_ROUTES = [
    ERROR_ROUTE,
];

export const PRIVATE_ROUTES = [
    TASKS_LIST_ROUTE,
    TASKS_GRAPH_ROUTE,
    CONFIRMATION_CALLS_ROUTE,
    STATISTICS,
    KPI_ROUTE,
    PAYMENTS_ROUTE,
    CUSTOMER_DETAILS_ROUTE,
    STORAGE_EXPECTED_INCOME_ROUTE,
    MC_OPS_DASHBOARD_ROUTE,
    MC_OPS_JOB_ROUTE
];
